import React from 'react';
import { Link } from 'react-router-dom';

function Proximamente() {
    return (
        <div className="container mt-5 text-center">
            <div className="card shadow-sm p-5">
                <h1 className="display-4">🚧 Próximamente 🚧</h1>
                <p className="lead">
                    Este sistema aún está en construcción. ¡Vuelve pronto para ver las novedades!
                </p>
                <div className="mt-4">
                    <Link to="/dashboard" className="btn btn-primary">
                        Volver al Dashboard
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Proximamente;